import { defineMessages } from 'react-intl'

export default defineMessages({
  notifyProducer: {
    id: 'containers.OrderPage.components.TaskPage.components.ActionsMenuFragments.notifyProducer',
    defaultMessage: 'Notify Producer of ready files',
  },
  notifyProducerConfirm: {
    id: 'containers.OrderPage.components.TaskPage.components.ActionsMenuFragments.notifyProducerConfirm',
    defaultMessage: 'Are you sure that the files are ready for post production?',
  },
  notifyProducerSuccess: {
    id: 'containers.OrderPage.components.TaskPage.components.ActionsMenuFragments.notifyProducerSuccess',
    defaultMessage: 'Producer notified',
  },
  notifyProducerError: {
    id: 'containers.OrderPage.components.TaskPage.components.ActionsMenuFragments.notifyProducerError',
    defaultMessage: 'Failed to notify post producer!\n{errors}',
  },
})
